import { CommandBase } from "../CommandBase.js";

export class HomeCommand extends CommandBase {
    constructor(kernel) {
        super(kernel);
        this.eventBus = kernel.get('eventBus');
    }
    async execute(args) {
        this.write(`Switching to GUI section: /home...`, 'text-muted');
        // Emits event to the GUI controller to change the page
        this.eventBus.emit('page:navigate', { section: 'home' });
    }
}